import GATSBY_COMPILED_MDX from "/home/runner/work/capsulecrm.com/capsulecrm.com/src/mdxPages/crm-glossary/index.fr.mdx";
import * as React from "react";
import {graphql} from "gatsby";
import MDXContentWrapper from "@/components/MDXContentWrapper";
import MainLayout from "@/layouts/MainLayout";
import CenteredHero from "@/components/CenteredHero";
import Longform from "@/components/Longform";
import SharedHead from "@/components/SharedHead";
export const Head = props => {
  const {data} = props;
  return React.createElement(SharedHead, Object.assign({}, props, {
    title: data.mdx.frontmatter.title,
    description: data.mdx.frontmatter.summary
  }));
};
function CrmGlossaryLayout({data, children}) {
  return React.createElement(MainLayout, null, React.createElement(CenteredHero, {
    title: data.mdx.frontmatter.display_title,
    backgroundClass: "pt-15 mb-20 bg-grey-1"
  }), React.createElement("div", {
    className: "container-fluid"
  }, React.createElement("section", {
    className: "section-sp--sm row"
  }, React.createElement("div", {
    className: "col-md-8 col-md-offset-2"
  }, React.createElement(Longform, null, React.createElement(MDXContentWrapper, null, children))))));
}
export const query = graphql`
  query ($id: String!) {
    ...Locales
    mdx(id: { eq: $id }) {
      frontmatter {
        display_title
        title
        summary
      }
      body
      id
    }
  }
`;
CrmGlossaryLayout
export default function GatsbyMDXWrapper(props) {
  return React.createElement(CrmGlossaryLayout, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
